const CN_CUSTOM = {

}

export default CN_CUSTOM;